import { h, Fragment } from "preact";
import { useMemo, useState, useEffect } from "preact/hooks";
import { formatMoney } from "utils/storefront/format-resource";
import IconShipping from "utils/icon/icon-shipping.svg";
import IconCheckmark from "utils/icon/icon-checkmark.svg";
import IconThreshold from "utils/icon/icon-threshold.svg";
import { withCartContext } from "./cart-context";

export const CartThreshold = ({
  cart,
  customerTags,
  active,
  hideVisually,
  hideShippingText,
  amountType,
  threshold,
  thresholdAmount,
  beforeMessage,
  afterMessage,
  rewardMessageSub,
  startMessage,
  rewardMessage,
  cartPage,
  showProgress,
  showMessage,
  milestones,
  setIsThresholdFull,
  hasSubscriptionProduct,
  fsThreshold,
}) => {
  if (!active && !fsThreshold?.active) {
    return null;
  }

  const [customerIsVIP, setCustomerIsVIP] = useState(false);
  const [cartTotalValue, setCartTotalValue] = useState(0);
  const [reachedShippingThreshold, setReachedShippingThreshold] = useState(false);
  const [reachedMilestoneThreshold, setReachedMilestoneThreshold] = useState(false);
  const [reachedMilestone2Threshold, setReachedMilestone2Threshold] = useState(false);
  const [hasReachedHighestThreshold, setHasReachedHighestThreshold] = useState(false);
  const [highestThreshold, setHighestThreshold] = useState(0);
  const [cartLastValue, setCartLastValue] = useState(0);
  const [cartValueProgressed, setCartValueProgressed] = useState(false);
  const [lowestThreshold, setLowestThreshold] = useState(0);
  const {milestoneEnabled, milestoneThreshold, milestoneThresholdAmount, milestoneBarLabel, milestoneLabelBefore, milestoneLabelAfter, milestoneIcon} = milestones[0];
  const {milestone2Enabled, milestone2Threshold, milestone2ThresholdAmount, milestone2BarLabel, milestone2LabelBefore, milestone2LabelAfter, milestone2Icon} = milestones[1];
  let availableProgress = true;
  let availableMessage = true;

  if (cartPage) {
    availableProgress = showProgress;
    availableMessage = showMessage;
  }

  useEffect(() => {
    const hasVIPTags = customerTags?.some((tag) =>
      tag.toLowerCase().includes("swell_vip_spf enthusiast") || tag.toLowerCase().includes("swell_vip_spf obsessed")
    );
    setCustomerIsVIP(!!hasVIPTags);
  }, []);

  useEffect(() => {
    if (cart.state[amountType]) {
      setCartTotalValue(cart.state[amountType]);
    } else {
      setCartTotalValue(0);
    }
  }, [cart]);

  const { message, percent, fsPercent } = useMemo(() => {
    setReachedShippingThreshold(false);
    setReachedMilestoneThreshold(false);
    setReachedMilestone2Threshold(false);
    if (!cart.state.items || cart.state.items.length === 0) {
      if (customerIsVIP && milestoneEnabled) {
        return {
          message: `<div class="font-semibold">${milestoneLabelBefore.replace(
            "[amount]",
            formatMoney(
              { amount: milestoneThreshold * 100 - cartTotalValue },
              true,
              true
            )
          )}</div>`,
          percent: 0,
          fsPercent: 0,
        };
      }
      return {
        message: `${thresholdAmount > 0 ? `<div>${hideShippingText ? '' : startMessage.replace(
          "[amount]",
          formatMoney(
            { amount: thresholdAmount * 100 - cartTotalValue },
            true,
            true
          )
        )}</div>` : ``}`,
        percent: 0,
        fsPercent: 0,
      };
    }
    if (milestoneEnabled) {
      if (hideShippingText) {
        if (cartTotalValue < milestoneThreshold * 100) {
          setReachedShippingThreshold(true);
          return {
            message: `<div class="font-semibold">${hasSubscriptionProduct ? rewardMessageSub : ''}</div>${milestoneLabelBefore.replace(
              "[amount]",
              `<span class="text-supergoop-blue">${formatMoney(
                { amount: (milestoneThreshold * 100) - cartTotalValue },
                true,
                true
            )}</span>`
            )}`,
            percent: (cartTotalValue / (highestThreshold * 100)) * (milestone2Enabled ? 20 : 45),
            fsPercent:
              (cartTotalValue / (fsThreshold?.thresholdAmount * 100)) * 100,
          };
        }
        if ((cartTotalValue >= milestoneThreshold * 100) && (milestone2Enabled ? cartTotalValue < milestone2Threshold * 100 : true)) {
          setReachedShippingThreshold(true);
          setReachedMilestoneThreshold(true);
          return {
            message: `<div class="font-semibold">${hasSubscriptionProduct ? rewardMessageSub : ''}</div><div>${milestoneLabelAfter}</div><div>${milestone2Enabled ? milestone2LabelBefore.replace(
              "[amount]",
              `<span class="text-supergoop-blue">${formatMoney(
                { amount: (milestone2Threshold * 100) - cartTotalValue },
                true,
                true
            )}</span>`
            ): ''}</div>`,
            percent: (cartTotalValue / (highestThreshold * 100)) * (milestone2Enabled ? 70 : 100),
            fsPercent:
              (cartTotalValue / (fsThreshold?.thresholdAmount * 100)) * 100,
          };
        }
        if ((cartTotalValue >= milestoneThreshold * 100) && (milestone2Enabled ? cartTotalValue >= milestone2Threshold * 100 : true)) {
          setReachedShippingThreshold(true);
          setReachedMilestoneThreshold(true);
          if (milestone2Enabled) {
            setReachedMilestone2Threshold(true);
          }
          return {
            message: `<div class="font-semibold">${hasSubscriptionProduct ? rewardMessageSub : ''}</div><div>${milestoneLabelAfter}</div><div>${milestone2Enabled ? milestone2LabelAfter.replace(
              "[amount]",
              `<span class="text-supergoop-blue">${formatMoney(
                { amount: (milestone2Threshold * 100) - cartTotalValue },
                true,
                true
            )}</span>`
            ) : ``}</div>`,
            percent: 100,
            fsPercent:
              (cartTotalValue / (fsThreshold?.thresholdAmount * 100)) * 100,
          };
        }
      }
      if ((cartTotalValue >= thresholdAmount * 100 || (hasSubscriptionProduct || customerIsVIP)) && (cartTotalValue < milestoneThreshold * 100)) {
        setReachedShippingThreshold(true);
        return {
          message: `<div class="font-semibold">${hasSubscriptionProduct ? rewardMessageSub : afterMessage}</div>${milestoneLabelBefore.replace(
            "[amount]",
            `<span class="text-supergoop-blue">${formatMoney(
              { amount: (milestoneThreshold * 100) - cartTotalValue },
              true,
              true
          )}</span>`
          )}`,
          percent: (cartTotalValue / (highestThreshold * 100)) * (hasSubscriptionProduct || customerIsVIP ? 25 : milestoneThreshold),
          fsPercent:
            (cartTotalValue / (fsThreshold?.thresholdAmount * 100)) * 100,
        };
      }
      if ((cartTotalValue >= thresholdAmount * 100) && (cartTotalValue >= milestoneThreshold * 100) && (milestone2Enabled ? cartTotalValue < milestone2Threshold * 100 : true)) {
        setReachedShippingThreshold(true);
        setReachedMilestoneThreshold(true);
        return {
          message: `<div class="font-semibold">${hasSubscriptionProduct ? rewardMessageSub : afterMessage}</div><div>${milestoneLabelAfter}</div><div>${milestone2Enabled ? milestone2LabelBefore.replace(
            "[amount]",
            `<span class="text-supergoop-blue">${formatMoney(
              { amount: (milestone2Threshold * 100) - cartTotalValue },
              true,
              true
          )}</span>`
          ): ''}</div>`,
          percent: (cartTotalValue / (highestThreshold * 100)) * (hasSubscriptionProduct && milestone2Enabled ? 70 : milestone2Enabled ? 80 : 100),
          fsPercent:
            (cartTotalValue / (fsThreshold?.thresholdAmount * 100)) * 100,
        };
      }
      if ((cartTotalValue >= thresholdAmount * 100) && (cartTotalValue >= milestoneThreshold * 100) && (milestone2Enabled ? cartTotalValue >= milestone2Threshold * 100 : true)) {
        setReachedShippingThreshold(true);
        setReachedMilestoneThreshold(true);
        if (milestone2Enabled) {
          setReachedMilestone2Threshold(true);
        }
        return {
          message: `<div class="font-semibold">${hasSubscriptionProduct ? rewardMessageSub : afterMessage}</div><div>${milestoneLabelAfter}</div><div>${milestone2Enabled ? milestone2LabelAfter.replace(
            "[amount]",
            `<span class="text-supergoop-blue">${formatMoney(
              { amount: (milestone2Threshold * 100) - cartTotalValue },
              true,
              true
          )}</span>`
          ) : ``}</div>`,
          percent: 100,
          fsPercent:
            (cartTotalValue / (fsThreshold?.thresholdAmount * 100)) * 100,
        };
      }
    } else {
      if (cartTotalValue >= thresholdAmount * 100 || (hasSubscriptionProduct || customerIsVIP)) {
        setReachedShippingThreshold(true);
        return {
          message: `<div class="font-semibold">${hasSubscriptionProduct ? rewardMessageSub : (hideShippingText ? '' : afterMessage)}</div>`,
          percent: 100,
          fsPercent:
            (cartTotalValue / (fsThreshold?.thresholdAmount * 100)) * 100,
        };
      }
    }
    return {
      message: hideShippingText ? '' : beforeMessage.replace(
        "[amount]",
        `<span class="text-supergoop-blue">${formatMoney(
          { amount: (thresholdAmount * 100) - cartTotalValue },
          true,
          true
        )}</span>`
      ),
      percent:
        (cartTotalValue / (highestThreshold * 100)) * 25,
      fsPercent:
        (cartTotalValue / (fsThreshold?.thresholdAmount * 100)) * 100,
    };
  }, [customerIsVIP, cartTotalValue, thresholdAmount, milestoneThreshold]);

  useEffect(() => {
    fsThreshold?.active
      ? setIsThresholdFull?.(fsPercent >= 100)
      : setIsThresholdFull?.(true);
  }, [fsPercent]);

  useEffect(() => {
    const highestThreshold = Math.max(thresholdAmount, (milestoneEnabled ? milestoneThreshold : 0), (milestone2Enabled ? milestone2Threshold : 0));
    setHighestThreshold(highestThreshold);
  }, []);

  useEffect(() => {
    if (cart?.state?.item_count === 0 && customerIsVIP && milestoneEnabled) {
      setLowestThreshold(milestoneThreshold);
      return;
    }
    const thresholds = [
      thresholdAmount,
      ...(milestoneEnabled ? [milestoneThreshold] : []),
      ...(milestone2Enabled ? [milestone2Threshold] : [])
    ].filter(threshold => threshold != null && threshold > 0);

    const lowestThreshold = thresholds.length > 0 ? Math.min(...thresholds) : 0;
    setLowestThreshold(lowestThreshold);
  }, [cart?.state?.item_count]);

  useEffect(() => {
    let reachedHighest = (cartTotalValue > 0) && (cartTotalValue >= highestThreshold * 100);

    if (customerIsVIP && !milestoneEnabled && !milestone2Enabled) {
      reachedHighest = true;
    }

    setHasReachedHighestThreshold(reachedHighest);

    if (cartTotalValue > cartLastValue) {
      setCartValueProgressed(true);
    } else {
      setCartValueProgressed(false);
    }

    setCartLastValue(cartTotalValue);
  }, [cartTotalValue]);

  const rewardsBanner = () => {
    return (
      <div className="relative overflow-hidden">
        <div className="bg-supergoop-yellow text-center px-5 py-2.5 flex items-center justify-center">
          <div
            className="body-xs font-medium text-grey-2A"
            dangerouslySetInnerHTML={{ __html: rewardMessage }}
          ></div>
        </div>
      </div>
    )
  }

  const shippingProgressBar = () => {
    return (
      <>
        <div
        className="text-[15px] text-grey-2A  ease-in-out duration-1000 text-center [&_strong]:text-supergoop-blue [&_strong]:font-normal"
        data-target="text-content"
        dangerouslySetInnerHTML={{ __html: message }}
      ></div>
        <div className={hideVisually ? 'hidden' : ''}>
          <div
            className={`absolute w-full h-full top-0 left-0 text-supergoop-blue z-10
              ${!hideShippingText && reachedShippingThreshold && thresholdAmount > 0 && !hasReachedHighestThreshold ? 'threshold-anim mt-0 ' : 'hidden -mt-[35px] '}`}
          >
            <div className="absolute scale-[1] left-6 top-6 rotate-12 opacity-90">
              <IconThreshold />
            </div>
            <div className="absolute scale-[0.3] left-1/2 top-3 opacity-50">
              <IconThreshold />
            </div>
            <div className="absolute scale-[0.4] left-2/3 top-14 -rotate-6 opacity-60">
              <IconThreshold />
            </div>
            <div className="absolute scale-[0.7] right-0 top-6 opacity-75">
              <IconThreshold />
            </div>
          </div>
          <div
            className={`absolute w-full h-full top-0 left-0 text-supergoop-blue z-10
              ${hasReachedHighestThreshold && cartValueProgressed ? 'threshold-anim mt-0 ' : 'hidden -mt-[35px] '}`}
          >
            <div className="absolute scale-[1] left-6 top-6 rotate-12 opacity-90">
              <IconThreshold />
            </div>
            <div className="absolute scale-[0.3] left-1/2 top-3 opacity-50">
              <IconThreshold />
            </div>
            <div className="absolute scale-[0.4] left-2/3 top-14 -rotate-6 opacity-60">
              <IconThreshold />
            </div>
            <div className="absolute scale-[0.7] right-0 top-6 opacity-75">
              <IconThreshold />
            </div>
          </div>
          <div
          className={`relative h-[4px] rounded bg-grey-B4 ${cart.state.item_count === 0 ? `my-4` : `mt-8 mb-14`} ${hasReachedHighestThreshold || (customerIsVIP && !milestoneEnabled && !milestone2Enabled) || (hasSubscriptionProduct && !milestoneEnabled && !milestone2Enabled) ? "hidden" : ""}`}
          >
            <div className={`w-full absolute flex justify-around`}>
              {cart?.state?.item_count == 0 || (!hasSubscriptionProduct && !customerIsVIP) && (!hideShippingText && thresholdAmount > 0) && (
              <div className="flex flex-col items-center">
                <div className={`relative rounded-full border-[3px] bg-grey-F7 grid place-content-center h-12 w-12 -mt-[1.4rem]
                  ${reachedShippingThreshold ? "border-supergoop-blue  text-grey-B4" : "border-grey-B4 text-supergoop-blue"}`}>
                  {reachedShippingThreshold && <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                    <IconCheckmark />
                  </div>}
                  <IconShipping />
                </div>
                <div className="flex flex-col text-[10px] mt-[6px] items-center">
                  <span className="font-bold text-supergoop-blue">{formatMoney({ amount: threshold }, false).replace(/\.\d+$/, '')}</span>
                  Free shipping
                </div>
              </div>
              )}
              {cart?.state?.item_count == 0 || milestoneEnabled && (
                <div className="flex flex-col items-center">
                  <div className={`relative rounded-full border-[3px] bg-grey-F7 grid place-content-center h-12 w-12 -mt-[1.4rem]
                    ${reachedMilestoneThreshold ? "border-supergoop-blue" : "border-grey-B4"}`}>
                    {reachedMilestoneThreshold && <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                      <IconCheckmark />
                    </div>}
                    {milestoneIcon && (
                      <img
                        src={milestoneIcon.src}
                        alt={milestoneIcon.alt}
                        className={`w-12 h-12 ${reachedMilestoneThreshold && `threshold-reached`}`}
                      />
                    )}
                  </div>
                  <div className="flex flex-col text-[10px] mt-[6px] items-center">
                    <span className="font-bold text-supergoop-blue">{formatMoney({ amount: milestoneThresholdAmount }, false).replace(/\.\d+$/, '')}</span>
                    {milestoneBarLabel}
                  </div>
                </div>
              )}
              {cart?.state?.item_count == 0 || milestone2Enabled && (
                <div className="flex flex-col items-center">
                  <div className={`relative rounded-full border-[3px] bg-grey-F7 grid place-content-center h-12 w-12 -mt-[1.4rem]
                    ${reachedMilestone2Threshold ? "border-supergoop-blue" : "border-grey-B4"}`}>
                    {reachedMilestone2Threshold && <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                      <IconCheckmark />
                    </div>}
                    {milestone2Icon && (
                      <img
                        src={milestone2Icon.src}
                        alt={milestone2Icon.alt}
                        className={`w-12 h-12 ${reachedMilestone2Threshold && `threshold-reached`}`}
                      />
                    )}
                  </div>
                  <div className="flex flex-col text-[10px] mt-[6px] items-center">
                    <span className="font-bold text-supergoop-blue">{formatMoney({ amount: milestone2ThresholdAmount }, false).replace(/\.\d+$/, '')}</span>
                    {milestone2BarLabel}
                  </div>
                </div>
              )}
            </div>
            <div
              className="h-full rounded bg-supergoop-blue ease-in-out duration-500"
              style={{ width: `${percent}%` }}
            ></div>
            {cart?.state?.item_count == 0 && (
              <div className={`w-full flex justify-between text-supergoop-blue font-bold body-xs mt-1 ${percent === 100 ? 'hidden' : ''}`}>
                <div>{formatMoney({ amount: 0 }, false).replace(/\.\d+$/, '')}</div>
                <div>
                  {formatMoney({ amount: lowestThreshold }, false).replace(/\.\d+$/, '')}
                </div>
              </div>
            )}
          </div>
        </div>
    </>
    )
  }

  const states = useMemo(() => {
    if (active) {
      return (
        <div className="relative threshold-message overflow-hidden">
          {cart?.state?.item_count > 0 && availableMessage && rewardMessage && (
            rewardsBanner()
          )}

          <div className={`relative overflow-hidden ${cartPage ? " " : "border-b border-grey-D0 "} ${cartPage && availableProgress && !availableMessage ? "" : cartPage ? "lg:hidden" : ""}`}>
            <div className="bg-grey-F7 px-5 py-4">
              {shippingProgressBar()}
            </div>
          </div>
        </div>
      );
    }
  }, [customerTags, cart.state]);
  return states;
};

export default withCartContext(CartThreshold);
